export default __webpack_public_path__ + "static/media/second.07a3f5f4.png";